import React from 'react';
import { useLocation } from 'react-router-dom';
import useAuth from 'customHook/useAuth'
import { Menu, Title, Item, Logout } from './styles'
import Cross from 'assets/svg/cross.svg'

const AccountNav = ({
  popUpRef,
  open,
  setOpen
}) => {

  const { userLogout } = useAuth();
  const { pathname } = useLocation();

  return (
    <Menu open={open} ref={popUpRef}>
      <Title>
        <img
          src={Cross}
          alt="cross"
          onClick={()=>{
            setOpen(false)
          }}
        />
      </Title>
        <Item
          className={pathname==='/profile'? 'active':''}
          to={'/profile'}
        >
          PROFILE
        </Item>
      <Logout
        onClick={userLogout}
      >
        LOG OUT
      </Logout>
    </Menu>
  );
};

export default AccountNav;
